const config = {
    baseUrl: '/',
    apiUrl: 'https://api.krishikhamar.com/api/',
    // apiUrl1: 'https://sgi-api.phicsart.com/api/',
    fileUrl: 'https://krishikhamar.com/assets/img/',
    fileUrl1: 'https://file.krishikhamar.com/'
};

export default config;